import { Route, Routes } from 'react-router-dom';
import Header from './pages/layout/header/main';
import rutas from './routes/config';
import Footer from './pages/layout/footer';
import './App.css';
import { Nav } from './components/Sidebar/Nav';

function App() { 
  return (   
    <div className="App">
      <header>
          <Header /> 
          <Nav />       
      </header>
      <main className="principal_container">
      <Routes>        
        { rutas.map( (ruta) =>
            <Route key={ruta.path} path={ruta.path} element={<ruta.component />} />
        ) }
      </Routes> 
      </main>
      <footer>
        <Footer/>
      </footer>
    </div>  
  );
}

export default App;
